import { render, staticRenderFns } from "./Intouch.vue?vue&type=template&id=0fb19f95&"
import script from "./Intouch.vue?vue&type=script&lang=js&"
export * from "./Intouch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports